// THE BIG 6 — web persona registry (from the design handoff). Public archetype
// labels + market + accent colour + blurb + trigger name per neutral persona
// slug. The real-professional lineage stays internal. Order = canonical
// PERSONA_ORDER used by the convergence dots.

export type Big6Persona = "totals" | "spread" | "props" | "global" | "nonnba" | "b2b";

export const PERSONA_ORDER: readonly Big6Persona[] = ["totals", "spread", "props", "global", "nonnba", "b2b"];

export interface Big6PersonaMeta {
  readonly slug: Big6Persona;
  readonly name: string;        // public archetype label
  readonly market: string;
  readonly accent: string;      // persona accent colour
  readonly blurb: string;       // one-line philosophy (outputs-only language)
  readonly triggerName: string; // the persona-specific BFPE trigger label
}

export const PERSONAS: Readonly<Record<Big6Persona, Big6PersonaMeta>> = {
  totals: { slug: "totals", name: "The Totals Maven", market: "Totals · Over/Under", accent: "#2dd4bf",
    blurb: "Pace, rest, defensive identity — calibrated against three season tapes before a number lifts off the board.",
    triggerName: "The Pace Trigger" },
  spread: { slug: "spread", name: "The Spread Sharp", market: "Spread · Cover", accent: "#e0566b",
    blurb: "Two-team net rating divergence, schedule rest, and home/road splits — only the games that move on the line.",
    triggerName: "The Net Rating Trigger" },
  props: { slug: "props", name: "The Prop Modeller", market: "Player Props · O/U", accent: "#a855f7",
    blurb: "Usage, opponent defence, pace, minutes projection — every prop carries a staleness clock; misses we do not chase.",
    triggerName: "The Usage Trigger" },
  global: { slug: "global", name: "The Global Volume", market: "Pinnacle-tracked Edges", accent: "#eab308",
    blurb: "World basketball at scale — every market the Pinnacle line has settled across a meaningful sample.",
    triggerName: "The Pinnacle Trigger" },
  nonnba: { slug: "nonnba", name: "The Overlooked Market", market: "Non-NBA Leagues", accent: "#34c759",
    blurb: "EuroLeague, NBL, LNB, LBA, Liga ACB — the markets the books model lightest and we model hardest.",
    triggerName: "The Light Book Trigger" },
  b2b: { slug: "b2b", name: "Sharp Collective", market: "Cross-Market Convergence", accent: "#5b78f0",
    blurb: "Only games where two or more personas independently land on the same side. Convergence is the signal.",
    triggerName: "The Convergence Trigger" },
};

export function isBig6Persona(s: string): s is Big6Persona {
  return s in PERSONAS;
}
